import { render, staticRenderFns } from "./multiVersionH5.vue?vue&type=template&id=71850838&scoped=true&"
import script from "./multiVersionH5.vue?vue&type=script&lang=js&"
export * from "./multiVersionH5.vue?vue&type=script&lang=js&"
import style0 from "./multiVersionH5.vue?vue&type=style&index=0&id=71850838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71850838",
  null
  
)

export default component.exports